import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import SuspenseLoader from 'src/components/SuspenseLoader/SuspenseLoader';
import { useAuth0 } from '@auth0/auth0-react';
import { useSafeAccessAuth0Token } from 'src/hooks/useSafeAccessAuth0Token';
import { getLatestTerms } from 'src/api/termsAndConditions';
import styles from '../../content/pages/homepage.module.css';
import { PureLightThemeCaaS } from 'src/theme/schemes/PureLightTheme';

interface ReadTermsAndConditionsProps {
    handleBack: () => void;
    handleClose: () => void;
}

const ReadTermsAndConditions = ({ handleBack, handleClose }: ReadTermsAndConditionsProps) => {
    const { isAuthenticated, isLoading: isAuthLoading } = useAuth0();
    const { getSafeAccessAuth0Token } = useSafeAccessAuth0Token();
    const [termsText, setTermsText] = useState("");
    const [isLoading, setIsLoading] = useState(true);


    const fetchTerms = async () => {
        try {
            let token;
            if (isAuthenticated) {
                token = await getSafeAccessAuth0Token();
            }
            const latestTerms = await getLatestTerms(token || undefined);
            setTermsText(latestTerms.text);
        } catch (error) {
            console.error("Failed to fetch terms:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isAuthLoading) return;

        fetchTerms();
    }, [isAuthenticated, isAuthLoading, getSafeAccessAuth0Token]);

    if (isAuthLoading || isLoading) {
        // return <SuspenseLoader />;
        return <Box
        sx={{
          position: "fixed",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          bgcolor: "#EDEDED",
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress size={64} disableShrink thickness={3} sx={{ color: `${PureLightThemeCaaS.colors.alpha.orange[100]}` }} />
      </Box>

    }

    if (!termsText) {
        return null;
    }

    return (
        <Box
            sx={{
                flex: 1,
                overflowY: 'auto',
                minHeight: 0,
                p: 3,
                pt: 3,
                WebkitOverflowScrolling: 'touch',
                m: '0 auto',
                bgcolor: '#EDEDED',
            }}
        >
            {/* <Typography variant="h4" textAlign="center" fontSize="23px" mb={2}>
                Terms and Conditions
            </Typography> */}
            <Typography variant="body1" fontSize="16px" p={0}>
                <ReactMarkdown className={styles.TermsReactMarkdown}>{termsText}</ReactMarkdown>
            </Typography>
        </Box>
    );
};

export default ReadTermsAndConditions;
